import {SellerLocation} from './sellerLocation.model';
import {Site} from '../site';
import {AssetPackageDto} from '../asset-package';
import {Asset} from './asset.model';
import {AuctionEvent} from '../auction-event';
import {RBA_LIVE, E_RESERVE, MAKE_OFFER, BUY_NOW, SELLER_BID_SELECT, SEALED_BID_SELLER_BID_SELECT} from './asset-sale-type';
import {IRONPLANET, RBA, SALVAGESALE} from "./asset-platform";
import {Address} from "@rbaip/address-form";
import {AGRICULTURAL_OPPORTUNITY} from "./opportunity-record-type.const";
import {equipmentState} from "./equipment-state";

export class AssetSaleInfo {
  opportunityId: number;
  assetControlGroupId: number;
  saleType: string;
  platformName: string;
  auctionEventId: number;
  locationId: number;
  siteId: number;
  siteLocation: SellerLocation;
  inspectionType: string;
  yardDeliveyDate: Date;
  isEditable: boolean = true;
  displayPrices: boolean = true;
  displayListingFee: boolean = true;
  displayBudget: boolean = true;
  displaySetDefaultCheckBox: boolean = true;
  newLocation: SellerLocation;
  newSellerLocation: SellerLocation;
  isAuctionSite: boolean;
  addNewAddress: boolean;
  shootPrice: number;
  tmShootPrice : number;
  forcedConsensusValue : number;
  algoPriceAmt: number;
  strikePriceAmt: number;
  sellerReserveAmt: number;
  listFeeAmt: number;
  make: string;
  model: string;
  manufacturingYear: any;
  yearFrom: number;
  acgSalesCordinator: string;
  acgTMUserName: string;
  opportunityCurrency: string;
  setDefault: boolean = true;
  rnrBudget: number;
  totalRnr: number;
  rnrBudgetLimit: number;
  saveAttempted: boolean;
  haulingBudget: number;
  haulingBudgetLimit: number;
  totalHauling: number;
  highlightRequiredField: boolean = true;
  rbAuctionEvents: Array<AuctionEvent> = [];
  assetControlGroupLocations: Array<SellerLocation> = [];
  siteList: Array<Site> = [];
  marketValue: number;
  displayOnlyFutureEvents: boolean = false;
  canModifyEvent: boolean = true;
  isPostContract: boolean = false;
  equipmentStatus: number;
  equipmentStatusName: string;
  assetStatusId: number;
  isMissingLocation: boolean = false;
  locationName: string;
  auctionEventName: string;
  assetLocationCountry:string;
  notifyPriceAmt: number;
  doNotShowAsk: boolean = false;
  notifySellerYn: boolean = false;
  showMakeOfferYn: boolean = true;
  showBuyNowYn: boolean = true;
  rejectPriceAmt: number;
  auctionEventLocationType: string;
  appraisalLocationId: number;
  newAppraisalLocation: SellerLocation;
  newAppraisalSellerLocation: SellerLocation;
  addNewAppraisalAddress: boolean;
  appraisalLocationName: string;
  areLocationsSame: boolean = true;

  isSaleInfoFromACG = true;
  recalculateYardDeliveryDate = true;
  locationChangeWarning = false;
  isRBRealm: boolean = false;
  yearTo: number = new Date().getFullYear();
  offSite: boolean;
  selectedAuctionEvent: AuctionEvent;
  selectedSite: Site;
  isAgOpportunity: boolean;
  isIPWebOperated: boolean;
  shouldBeDisabledDuringMove: boolean;
  equipId: number;
  isMissingContact: boolean = false;
  validContact: boolean = false;
  isEditContact: boolean = false; // using for bulk edit


  public static getSaleInfoFromAssetControlGroup(assetControlGroup: AssetPackageDto): AssetSaleInfo {
    const assetSaleInfo = new AssetSaleInfo();
    assetSaleInfo.inspectionType = assetControlGroup.defaultInspectionType;
    assetSaleInfo.siteId = assetControlGroup.defaultSiteId;
    assetSaleInfo.locationId = assetControlGroup.locationId;
    assetSaleInfo.opportunityId = assetControlGroup.opportunityId;
    assetSaleInfo.assetControlGroupId = assetControlGroup.acgId;
    assetSaleInfo.auctionEventId = assetControlGroup.defaultAuctionEventId;
    assetSaleInfo.saleType = assetControlGroup.defaultSaleType;
    assetSaleInfo.yardDeliveyDate = assetControlGroup.defaultYardDeliveyDt;
    assetSaleInfo.isAuctionSite = (assetControlGroup.defaultSiteId != null);
    assetSaleInfo.displayPrices = false;
    assetSaleInfo.displayListingFee = false;
    assetSaleInfo.displayBudget = false;
    assetSaleInfo.displaySetDefaultCheckBox = false;
    assetSaleInfo.acgTMUserName = assetControlGroup.acgTMUserName;
    assetSaleInfo.acgSalesCordinator = assetControlGroup.acgSalesCordinator;
    assetSaleInfo.opportunityCurrency = assetControlGroup.currency;
    assetSaleInfo.rnrBudgetLimit = assetControlGroup.rnrBudgetLimit;
    assetSaleInfo.haulingBudgetLimit = assetControlGroup.haulingBudgetLimit;
    if ( assetSaleInfo.saleType ) {
      assetSaleInfo.setDefault = false;
      if (assetSaleInfo.saleType == RBA_LIVE)
        assetSaleInfo.platformName = RBA;
      else
        assetSaleInfo.platformName = IRONPLANET;
    }
    assetSaleInfo.locationName = assetControlGroup.sellerLocation ? assetControlGroup.sellerLocation.locationDesc : '';
    assetSaleInfo.assetLocationCountry = assetControlGroup.sellerLocation ? assetControlGroup.sellerLocation.country : "";
    assetSaleInfo.isAgOpportunity = assetControlGroup.opportunityRecordType && assetControlGroup.opportunityRecordType === AGRICULTURAL_OPPORTUNITY;
    assetSaleInfo.isIPWebOperated = assetControlGroup.isIPWebOperated;
    assetSaleInfo.newSellerLocation = assetControlGroup.sellerLocation;
    return assetSaleInfo;
  }

  public static getSaleInfoFromAsset(asset: Asset, assetControlGroup: AssetPackageDto): AssetSaleInfo {
    const assetSaleInfo = new AssetSaleInfo();
    assetSaleInfo.inspectionType = asset.inspectionType;
    assetSaleInfo.siteId = asset.siteId;
    assetSaleInfo.locationId = asset.locationId;
    assetSaleInfo.auctionEventId = asset.auctionEventId;
    assetSaleInfo.auctionEventName = asset.auctionEventName;
    assetSaleInfo.saleType = asset.saleType;
    assetSaleInfo.isRBRealm = Asset.isRBRealm(asset);
    assetSaleInfo.platformName = asset.platformName;
    assetSaleInfo.yardDeliveyDate = asset.yardDeliveyDt;
    assetSaleInfo.isAuctionSite = !!asset.siteId;
    assetSaleInfo.displayPrices = false;
    assetSaleInfo.displayListingFee = false;
    assetSaleInfo.displayBudget = false;
    assetSaleInfo.displaySetDefaultCheckBox = false;
    assetSaleInfo.sellerReserveAmt = asset.sellerReserveAmt;
    assetSaleInfo.strikePriceAmt = asset.strikePriceAmt;
    assetSaleInfo.shootPrice =  asset.shootPrice;
    assetSaleInfo.tmShootPrice = asset.tmShootPrice;
    assetSaleInfo.forcedConsensusValue = asset.forcedConsensusValue;
    assetSaleInfo.algoPriceAmt =  asset.algoPriceAmt;
    assetSaleInfo.listFeeAmt = asset.listFeeAmt;
    assetSaleInfo.rnrBudget = asset.rnrBudget;
    assetSaleInfo.haulingBudget = asset.haulingBudget;
    if ( assetSaleInfo.saleType ){
      assetSaleInfo.setDefault = false;
    }
    assetSaleInfo.marketValue = asset.marketValue;
    assetSaleInfo.isPostContract = !!asset.equipId;
    assetSaleInfo.equipId = asset.equipId;
    assetSaleInfo.equipmentStatus = asset.equipmentStatus;
    assetSaleInfo.shouldBeDisabledDuringMove = asset.equipmentStatus >= equipmentState.inspectionPerformed;
    assetSaleInfo.equipmentStatusName = asset.equipmentStatusName;
    assetSaleInfo.assetStatusId = asset.assetStatusId;
    assetSaleInfo.make = asset.manufacturerName;
    assetSaleInfo.model = asset.modelName;
    assetSaleInfo.yearFrom = parseInt(asset.year);
    if(assetSaleInfo.yearFrom > new Date().getFullYear()){
      assetSaleInfo.yearFrom = new Date().getFullYear();
    }
    assetSaleInfo.manufacturingYear = asset.year;
    assetSaleInfo.locationName = asset.assetLocationDto ? asset.assetLocationDto.locationDesc : '';
    assetSaleInfo.assetLocationCountry = asset.assetLocationDto ? asset.assetLocationDto.country : "";
    assetSaleInfo.isSaleInfoFromACG = false;
    assetSaleInfo.recalculateYardDeliveryDate = false;
    assetSaleInfo.notifyPriceAmt = asset.notifyPriceAmt;
    assetSaleInfo.doNotShowAsk = !asset.revealResvYn;
    assetSaleInfo.notifySellerYn = asset.notifySellerYn;
    assetSaleInfo.showMakeOfferYn = asset.showMakeOfferYn;
    assetSaleInfo.showBuyNowYn = asset.showBuyNowYn;
    assetSaleInfo.rejectPriceAmt = asset.rejectPriceAmt;
    assetSaleInfo.offSite = asset.offSite;
    assetSaleInfo.appraisalLocationId = asset.appraisalLocationId;
    assetSaleInfo.appraisalLocationName = asset.appraisalLocationDto ? asset.appraisalLocationDto.locationDesc : '';
    assetSaleInfo.areLocationsSame = !asset.appraisalLocationId || (asset.locationId === asset.appraisalLocationId);

    if (assetControlGroup) {
      assetSaleInfo.opportunityId = assetControlGroup.opportunityId;
      assetSaleInfo.assetControlGroupId = assetControlGroup.acgId;
      assetSaleInfo.acgTMUserName = assetControlGroup.acgTMUserName;
      assetSaleInfo.acgSalesCordinator = assetControlGroup.acgSalesCordinator;
      assetSaleInfo.opportunityCurrency = assetControlGroup.currency;
      assetSaleInfo.rnrBudgetLimit = assetControlGroup.rnrBudgetLimit;
      assetSaleInfo.haulingBudgetLimit = assetControlGroup.haulingBudgetLimit;
      assetSaleInfo.setDefault = !assetControlGroup.defaultSaleType;
      assetSaleInfo.isIPWebOperated = assetControlGroup.isIPWebOperated;
    } else {
      assetSaleInfo.acgTMUserName = asset.terrManangerName;
      assetSaleInfo.opportunityCurrency = asset.currencyCode;
    }

    if ( assetSaleInfo.saleType ) {
      assetSaleInfo.setDefault = false;
    }

    if (asset.siteId === null && asset.assetLocationDto && this.checkContactInfo(asset.assetLocationDto.inspContact)
      && this.checkContactInfo(asset.assetLocationDto.transportContact)) {
      assetSaleInfo.isMissingContact = false;
      assetSaleInfo.validContact = true;
    }
    return assetSaleInfo;
  }

  public static resetSaleInfoForAsset(asset: Asset): void {
    asset.saleType = null;
    asset.platformName = null;
    asset.auctionEventId = null;
    asset.inspectionType = null;
    asset.siteId = null;
    asset.locationId = null;
    asset.assetLocationDto = null;
    asset.sellerReserveAmt = null;
    asset.strikePriceAmt = null;
    asset.shootPrice = null;
    asset.resvPriceAmt = null;
    asset.notifyPriceAmt = null;
    asset.algoPriceAmt = null;
    asset.revealResvYn = null;
    asset.notifySellerYn = null;
    asset.showMakeOfferYn = null;
    asset.showBuyNowYn = null;
    asset.rejectPriceAmt = null;
    asset.appraisalLocationId = null;
  }

  public setAssetControlGroupWithSaleInfo(assetControlGroup: AssetPackageDto): AssetPackageDto {
    assetControlGroup.defaultInspectionType = this.inspectionType;
    assetControlGroup.opportunityId = this.opportunityId;
    assetControlGroup.defaultSaleType = this.saleType;
    assetControlGroup.defaultAuctionEventId = (this.saleType === RBA_LIVE ? this.auctionEventId : null);
    assetControlGroup.defaultSiteId = null;
    assetControlGroup.sellerLocation = null;
    assetControlGroup.locationId = null;
    assetControlGroup.defaultYardDeliveyDt = null;
    assetControlGroup.auctionSite  = false;
    if (this.isAuctionSite) {
      assetControlGroup.defaultSiteId = this.siteId;
      assetControlGroup.defaultYardDeliveyDt = this.yardDeliveyDate;
      assetControlGroup.sellerLocation = this.siteLocation;
      assetControlGroup.auctionSite  = true;
    } else if (this.addNewAddress) {
      if (this.isValidAddress()) {
        assetControlGroup.sellerLocation = this.newLocation;
      }
    } else {
      assetControlGroup.locationId = this.locationId;
    }
    return assetControlGroup;
  }

  public isValidAddress(): boolean {
    return this.isValidAddressLocation(this.newLocation);
  }

  public isValidContact(): boolean {
    if(this.addNewAddress) {
      return this.isvalidContactInfo(this.newLocation);
    }else{
      return this.isvalidContactInfo(this.siteLocation);
    }
  }

  public isvalidContactInfo(location: SellerLocation): boolean {
    if (!this.isAuctionSite && this.saleType != RBA_LIVE) {
      if (location && (AssetSaleInfo.checkContactInfo(location.inspContact) && AssetSaleInfo.checkContactInfo(location.transportContact))) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  public isValidAddressLocation(location: SellerLocation): boolean {
    let validAddress = true;
    const newAddress = location ? location.addressDto : null;
    if (!newAddress || !newAddress.country || (!newAddress.address && !newAddress.city && !newAddress.postcode) || !location.locationDesc) {
      validAddress = false;
    }
    return validAddress;
  }

  public setAssetWithSaleInfo(assetDto: Asset): Asset {
    assetDto.saleType = this.saleType;
    assetDto.platformName = this.platformName;
    if (this.saleType) {
      assetDto.setDefault = false;
    }
    if (this.saleType != null && this.saleType === RBA_LIVE) {
      assetDto.auctionEventId = this.auctionEventId;
    } else {
      assetDto.auctionEventId = null;
    }
    if(this.rbAuctionEvents && this.auctionEventId){
      this.selectedAuctionEvent = this.rbAuctionEvents.filter(auctionEvent => auctionEvent.auctionEventId == this.auctionEventId)[0];
    }
    assetDto.auctionSite = this.isAuctionSite;
    assetDto.inspectionType = this.inspectionType;

    if (this.isAuctionSite) {
      if (this.siteId != null) {
        assetDto.yardDeliveyDt = this.yardDeliveyDate;
        assetDto.siteId = this.siteId;
        assetDto.assetLocationDto = this.siteLocation;
        if (assetDto.assetLocationDto == null) {
          assetDto.assetLocationDto = new SellerLocation();
        }
        assetDto.assetLocationDto.siteId = this.siteId;
        assetDto.locationId = this.locationId;
        if (this.selectedAuctionEvent && this.siteList ) {
          let selectedSite = this.siteList.filter(site => site.id === this.siteId)[0];
          this.offSite = !this.checkIfAssetIsOffSite(selectedSite.address, this.selectedAuctionEvent.eventLocationContactDto, null);
        }
      }
    } else if (!this.isAuctionSite) {
      if (this.addNewAddress) {
        const assetLocation = new SellerLocation();
        assetLocation.addressDto = this.newLocation.addressDto;
        assetDto.assetLocationDto = this.newLocation;
        assetDto.locationId = null;
        assetDto.siteId = null;
        if(this.selectedAuctionEvent ){
          this.offSite = !this.checkIfAssetIsOffSite(null, this.selectedAuctionEvent.eventLocationContactDto,  assetLocation.addressDto);
        }
      } else {
        assetDto.locationId = this.locationId;
        assetDto.siteId = null;
        assetDto.assetLocationDto = this.newSellerLocation;
        if (this.selectedAuctionEvent  && this.assetControlGroupLocations && this.locationId) {
          let sellerLocation = this.assetControlGroupLocations.filter(location => location.id === this.locationId)[0];
          if (sellerLocation) {
            this.offSite = !this.checkIfAssetIsOffSite(null, this.selectedAuctionEvent.eventLocationContactDto, sellerLocation.addressDto);
           }
        }
      }
    }

    if (this.areLocationsSame || this.locationId === this.appraisalLocationId) {
      assetDto.appraisalLocationDto = null;
      assetDto.appraisalLocationId = null;
    } else if (this.addNewAppraisalAddress) {
      assetDto.appraisalLocationDto = this.newAppraisalLocation;
      assetDto.appraisalLocationId = null;
    } else {
      assetDto.appraisalLocationId = this.appraisalLocationId;
      assetDto.appraisalLocationDto = this.newAppraisalSellerLocation;
    }

    assetDto.sellerReserveAmt = this.sellerReserveAmt;
    assetDto.strikePriceAmt = this.strikePriceAmt;
    assetDto.shootPrice = this.shootPrice;
    assetDto.algoPriceAmt = this.algoPriceAmt;
    if (this.isNegotiatedSale()) {
      assetDto.resvPriceAmt = this.strikePriceAmt;
      assetDto.notifyPriceAmt = this.notifyPriceAmt;
      assetDto.revealResvYn = !this.doNotShowAsk;
      assetDto.notifySellerYn = this.notifySellerYn;
      assetDto.showMakeOfferYn = this.showMakeOfferYn;
      assetDto.showBuyNowYn = this.showBuyNowYn;
      assetDto.rejectPriceAmt = this.rejectPriceAmt;
    } else {
      assetDto.notifyPriceAmt = 0;
      assetDto.revealResvYn = true;
      assetDto.notifySellerYn = false;
      assetDto.showMakeOfferYn = true;
      assetDto.showBuyNowYn = true;
      assetDto.rejectPriceAmt = 0;
      if (this.saleType === E_RESERVE) {
        assetDto.resvPriceAmt = this.sellerReserveAmt;
      } else {
        assetDto.resvPriceAmt = 0;
      }
    }
    assetDto.listFeeAmt = this.listFeeAmt;
    assetDto.offSite = this.offSite;
    return assetDto;
  }

  public isValid(): boolean {
    let valid = true;
    if ( !this.saleType ) {
      valid = false;
    } else if ( this.saleType === RBA_LIVE && !this.isAgOpportunity && !this.auctionEventId) {
      valid = false;
    } else if ( ( !this.addNewAddress && this.isMissingLocation) || ( this.addNewAddress && !this.isValidAddress() ) ) {
      valid = false;
    } else if ( !this.isValidSalePrices() ) {
      valid = false;
    } else if (!this.validContact && !this.isContactInfoMissing()){
      valid = false;
    } else if (this.validContact && this.saleType != RBA_LIVE && !this.isAuctionSite && this.isMissingContact){
      valid = false;
    }
    return valid;
  }

  public isValidSale() {
    return (this.saleType && this.saleType !== RBA_LIVE)
      || (this.saleType === RBA_LIVE && !this.isAgOpportunity && !this.auctionEventId);
  }
  public isValidForMultipleAssets(): boolean {
    let valid = true;
    if (!this.saleType) {
      valid = false;
    } else if(this.saleType === RBA_LIVE && !this.isAgOpportunity && !this.auctionEventId) {
      valid = false;
    } else if ((!this.addNewAddress && this.isMissingLocation) || (this.addNewAddress && !this.isValidAddress())) {
      valid = false;
    }else if (!this.isContactInfoMissing()){
      valid = false;
    }
    return valid;
  }

  /*
  If asset is in or passed Contract Ready, the following fields cannot be removed:
      - Sale Type
      - Event - If Sale Type is Live
      - Selling Location
      - Inspection Type - If the Event is VSO and the Location is Remote OR the Sale Type is not Live
      - Expected Yard Delivery Date - If the Selling Location is a RB Yard
      - Reserve Price
  */
  public isValidAfterContractReady(isVSOEvent: boolean): boolean {
    let valid = true;
    if (!this.saleType) {
      valid = false;
    } else if (!this.auctionEventId && this.saleType === RBA_LIVE) {
      valid = false;
    } else if (!this.addNewAddress && this.isMissingLocation) {
      valid = false;
    } else if (!this.inspectionType && ((isVSOEvent && !this.siteId) || this.saleType !== RBA_LIVE)) {
      valid = false;
    } else if (!this.yardDeliveyDate && this.isAuctionSite) {
      valid = false;
    } else if ( !this.isValidSalePrices() ) {
      valid = false;
    }
    return valid;
  }

  public isValidSalePrices(): boolean {
    let valid = true;
    if (this.saleType === E_RESERVE && ((!this.sellerReserveAmt || this.sellerReserveAmt < 1) && this.platformName !== SALVAGESALE)) {
      valid = false;
    }
    return valid;
  }

  public isNegotiatedSale(): boolean {
    return this.saleType === MAKE_OFFER || this.saleType === SELLER_BID_SELECT || this.saleType === SEALED_BID_SELLER_BID_SELECT;
  }

  public isSellerBidSelect(): boolean {
    return this.saleType === SELLER_BID_SELECT || this.saleType === SEALED_BID_SELLER_BID_SELECT;
  }

  public checkIfAssetIsOffSite(siteContact: Address, auctionEventContact : Address, selectedLocationContact: Address): boolean{
    if(auctionEventContact){
      if(siteContact){
        return this.isEventLocationIsSameAsAssetLocation(auctionEventContact, siteContact);
      } else if(selectedLocationContact) {
        return this.isEventLocationIsSameAsAssetLocation(auctionEventContact, selectedLocationContact);
      }
    }
  }

  public static isEqualsString(s1: string, s2:string) : boolean{
    return  (s1 == null && s2 == null) ||
      (s1 != null && s2 != null && ((s1==="" && s2==="") ||
        (s1===s2)));
  }

  public isEventLocationIsSameAsAssetLocation( eventLocation: Address, assetLocation: Address) {
    if (eventLocation && assetLocation) {
      return AssetSaleInfo.checkAddressesAreSame(eventLocation, assetLocation);
    } else {
      return false;
    }
  }
  public static checkLocationsAreSame(location1: SellerLocation, location2: SellerLocation) : boolean{
    return (location1 == location2 ||
      (location1 != null && location2 != null &&
        AssetSaleInfo.checkAddressesAreSame(location1.addressDto, location2.addressDto) ));
  }

  public static checkAddressesAreSame(address1: Address, address2: Address) : boolean{
    return (address1 == address2) ||
      (address1 != null && address2 != null &&
        AssetSaleInfo.isEqualsString(address1.city, address2.city) &&
        AssetSaleInfo.isEqualsString(address1.province, address2.province) &&
        AssetSaleInfo.isEqualsString(address1.postcode, address2.postcode) &&
        AssetSaleInfo.isEqualsString(address1.country, address2.country) &&
        AssetSaleInfo.isEqualsString(address1.address, address2.address));
  }

  public getAssetOrigin() : SellerLocation {
    let assetOrigin = null;

    // similar logic as setAssetWithSaleInfo
    if (this.areLocationsSame || this.locationId === this.appraisalLocationId) {
      // asset origin is same as selling location
      if (this.isAuctionSite) {
        if (this.siteId != null) {
          assetOrigin = this.siteLocation;
        }
      } else if (!this.isAuctionSite) {
        if (this.addNewAddress) {
          assetOrigin = this.newLocation;
        } else {
          assetOrigin = this.newSellerLocation;
        }
      }
    } else {
      // asset origin is different than selling location
      if (this.addNewAppraisalAddress) {
        assetOrigin = this.newAppraisalLocation;
      } else {
        assetOrigin = this.newAppraisalSellerLocation;
      }
    }

    return assetOrigin;
  }

  public isLiveAuction() : boolean {
    return  this.saleType === RBA_LIVE;
  }

  public static checkContactInfo(contactInfo): boolean {
    if(contactInfo && contactInfo.firstName && contactInfo.lastName && contactInfo.voicePhoneNumber && contactInfo.email){
      return true;
    }
    return false;
  }

  public isContactInfoMissing(): boolean {
    if(this.addNewAddress) {
      return this.isvalidContactInfo(this.newLocation);
    }else{
      return this.isvalidContactInfo(this.newSellerLocation);
    }
  }



}
